function resolveExportTarget(format, target) {
  if (!target) {
    return;
  }

  // For docx documents we only wish to include the actual content, but
  // not headers, footers and background content which otherwise would .
  return (format === "docx" ? target.querySelector("[data-word-target]") : undefined) ?? target.querySelector("[data-print-target]") ?? target;
}
function extractExportInput(format, target) {
  const gExport = window.gExport;
  switch (format) {
    case "pdf":
      if (!gExport) {
        throw new Error("extractTargetContent(): gExport must be loaded prior to extracting content");
      }
      return gExport.utils.extractWindowHtml(window, target);
    case "docx":
      // Unfortunately the styling options
      // are very limited in docx, so we
      // create a simplified output...
      return target.innerHTML.replace(/<h3[^>]*>/g, "<br /><b>").replace(/<\/h3>/g, "</b><br />");
  }
}
function applyCustomCssStylesheet(customCss) {
  if (!customCss) {
    return;
  }
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.media = "print";
  styleSheet.appendChild(document.createTextNode(customCss));
  document.body.appendChild(styleSheet);
  return styleSheet;
}
function hideIrrelevantNodes(target) {
  target.classList.add("component-framework__print--target");
  const nodesOnPage = document.querySelectorAll("*:not(.component-framework__print--target)");

  // Ensure that all other nodes than our target is completely hidden
  for (const node of nodesOnPage) {
    if (!(node instanceof HTMLElement)) {
      continue;
    }
    if (node.contains(target)) {
      node.classList.add("component_framework__print--parent");
      continue;
    }
    if (target.contains(node)) {
      continue;
    }
    node.classList.add("component_framework__print--hidden");
  }
}
function resetIrrelevantNodes(target) {
  target.classList.remove("component-framework__print--target");
  const nodesOnPage = document.querySelectorAll("*:not(.component-framework__print--target)");
  for (const node of nodesOnPage) {
    if (!(node instanceof HTMLElement)) {
      continue;
    }
    if (node.contains(target)) {
      node.classList.remove("component_framework__print--parent");
      continue;
    }
    if (target.contains(node)) {
      continue;
    }
    node.classList.remove("component_framework__print--hidden");
  }
}

export { applyCustomCssStylesheet, extractExportInput, hideIrrelevantNodes, resetIrrelevantNodes, resolveExportTarget };
import "./util.export.linaria.module.css";
//# sourceMappingURL=util.export.js.map
